// auth actions
export const USER_LOADED = "USER_LOADED";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const CLEAR_STORE = "CLEAR_STORE";

// read actions
export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_NEWS = "GET_NEWS";
export const GET_SERVICES = "GET_SERVICES";
export const GET_HISTORY = "GET_HISTORY";
export const GET_CONTACTS = "GET_CONTACTS";
export const GET_CONSTRUCTIONS = "GET_CONSTRUCTIONS";
export const GET_NAVIGATIONS = "GET_NAVIGATIONS";
export const GET_COMMENTS = "GET_COMMENTS";
export const GET_CAROUSEL = "GET_CAROUSEL";
export const GET_PROJECT = "GET_PROJECT";
export const GET_NETWORK = "GET_NETWORK";
export const GET_NETWORK_URL = "GET_NETWORK_URL";
export const GET_USER_COMMENT = "GET_USER_COMMENT";

//create actions
export const CREATE_CATEGORY = "CREATE_CATEGORY";
export const CREATE_SERVICE = "CREATE_SERVICE";
export const CREATE_COMMENT = "CREATE_COMMENT";
export const CREATE_CONSTRUCTION = "CREATE_CONSTRUCTION";
export const CREATE_NAVIGATION = "CREATE_NAVIGATION";
export const CREATE_NEWS = "CREATE_NEWS";
export const CREATE_HISTORY = "CREATE_HISTORY";
export const CREATE_CAROUSEL = "CREATE_CAROUSEL";
export const CREATE_PROJECT = "CREATE_PROJECT";
export const CREATE_NETWORK = "CREATE_NETWORK";
export const CREATE_NETWORK_URL = "CREATE_NETWORK_URL";
export const CREATE_USER_COMMENT = "CREATE_USER_COMMENT";

// delete actions
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const DELETE_SERVICE = "DELETE_SERVICE";
export const DELETE_COMMENT = "DELETE_COMMENT";
export const DELETE_CONSTRUCTION = "DELETE_CONSTRUCTION";
export const DELETE_NAVIGATION = "DELETE_NAVIGATION";
export const DELETE_NEWS = "DELETE_NEWS";
export const DELETE_HISTORY = "DELETE_HISTORY";
export const DELETE_CAROUSEL = "DELETE_CAROUSEL";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const DELETE_NETWORK = "DELETE_NETWORK";
export const DELETE_NETWORK_URL = "DELETE_NETWORK_URL";
export const DELETE_USER_COMMENT = "DELETE_USER_COMMENT";

// update actions
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const UPDATE_SERVICE = "UPDATE_SERVICE";
export const UPDATE_COMMENT = "UPDATE_COMMENT";
export const UPDATE_CONSTRUCTION = "UPDATE_CONSTRUCTION";
export const UPDATE_NAVIGATION = "UPDATE_NAVIGATION";
export const UPDATE_NEWS = "UPDATE_NEWS";
export const UPDATE_CONTACT = "UPDATE_CONTACT";
export const UPDATE_HISTORY = "UPDATE_HISTORY";
export const UPDATE_CAROUSEL = "UPDATE_CAROUSEL";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const UPDATE_NETWORK = "UPDATE_NETWORK";
export const UPDATE_NETWORK_URL = "UPDATE_NETWORK_URL";
export const UPDATE_USER_COMMENT = "UPDATE_USER_COMMENT";